module.exports = __webpack_public_path__ + "img/91.66e9bdc8.jpg";